import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCropAlt } from "@fortawesome/free-solid-svg-icons"

export const CropAlt = (props) => {
  return <FontAwesomeIcon faIcon={faCropAlt} {...props} />
}
